import { createApi } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { permissionAlertWithComment } from "../../alerts/alerts";

// export const baseUrl =
//     !process.env.NODE_ENV || process.env.NODE_ENV === "development"
//         ? "http://194.107.177.228/api/"
//         : "https://yountel.kiev.ua/api/";

export const baseUrl =
    !process.env.NODE_ENV || process.env.NODE_ENV === "development"
        ? "http://dev.yountel-crm.local/api/"
        : "https://yountel.kyiv.ua/api/";

const getToken = () => {
    return JSON.parse(localStorage.getItem("token"));
};

axios.defaults.withCredentials = true;
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["X-CSRF-TOKEN"] = getToken();

export const axiosBaseQuery =
    ({ baseUrl } = { baseUrl: "" }) =>
    async ({ url, method, body, params }) => {
        try {
            const isMultipart = body instanceof FormData;
            const result = await axios({
                url: baseUrl + url,
                method,
                data: body,
                params,
                headers: isMultipart ? { "Content-Type": "multipart/form-data" } : undefined,
            });
            return { data: result?.data };
        } catch (axiosError) {
            let err = axiosError;
            if (err.response?.status === 403) {
                permissionAlertWithComment(url.split("?")[0]);
            } else if (err?.response?.status === 404 || err?.response?.status === 422) {
                alert(err?.response?.data?.message);
            } else if (err?.response?.status === 418) {
                alert(err?.response?.data?.message);
            }

            return {
                error: {
                    status: err?.response?.status,
                    data: err?.response?.data || err.message,
                },
            };
        }
    };

export const crmAPI = createApi({
    reducerPath: "crmAPI",
    baseQuery: axiosBaseQuery({
        baseUrl: baseUrl,
    }),
    endpoints: (builder) => ({
        ping: builder.query({
            query: () => ({ url: "ping", method: "get" }),
        }),
        getPage: builder.query({
            query: (url) => ({ url: url, method: "get" }),
        }),
        getpUserPermissions: builder.query({
            query: () => ({ url: "user-permissions", method: "get" }),
        }),
        getpUserPermissionsTypes: builder.query({
            query: () => ({ url: "user-permission-types", method: "get" }),
        }),
        sendForm: builder.mutation({
            query: ({ body, url, method = "POST" }) => ({
                url: url,
                method: method,
                body: body,
            }),
        }),
    }),
});

export const {
    usePingQuery,
    useGetPageQuery,
    useSendFormMutation,
    useGetpUserPermissionsQuery,
    useGetpUserPermissionsTypesQuery,
    useLazyGetPageQuery,
} = crmAPI;
